import { render } from "./ReviewMeasurementsModal.vue?vue&type=template&id=7ba24b5b&ts=true"
import script from "./ReviewMeasurementsModal.vue?vue&type=script&lang=ts"
export * from "./ReviewMeasurementsModal.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__